import { companyTitles } from '../constants/companies';

export const getCurrentCompanyButtons = (currentCompany) => {
    const btnsList = ['file_link_1', 'file_link_2', 'file_link_3'];
    const companyButtons = [];

    btnsList.forEach(button => {
        if (currentCompany[button] && typeof currentCompany[button] === 'string') {
            companyButtons.push({
                type: button,
                title: companyTitles[button],
                link: currentCompany[button]
            });
        }
    });

    return companyButtons;
}

export const formatNumber = (value, title) => {
    const isValid = !Number.isNaN(Number(value)) && title !== 'edrpou_inn';
    if (isValid) {
        return value.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, " ");
    }

    return value;
}
